import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
import { getAuthorization } from './base'
import { LStorage } from './storage'

const isLoading = true
const isCheck = true
const base = "/mft_stock"

const http = axios.create({
  baseURL: 'api',
  timeout: 60000,
  headers: {
  }
})

var loadingInstance = null
http.interceptors.request.use(function (config) {
  if (isLoading) {
    loadingInstance = ElLoading.service({ fullscreen: true })
  }
  setRequestHeader(config)
  return config
}, function (error) {
  return error
})

http.interceptors.response.use(function (response) {
  if (isLoading) {
    loadingInstance.close()
  }
  if (isCheck) {
    if (response.data.hasOwnProperty('check_info') && response.data.check_info !== "") {
      if (response.data.check_info === 'not authenticated') {
        window.location.href = base + "/login";
      } else if (response.data.check_info === 'authenticated') {
        window.location.href = base + "/";
      } else if (response.data.check_info === 'expired') {
        window.location.href = base + "/pay";
      } else {
        ElMessage.error(response.data.check_info)
      }
      return Promise.reject(response)
    } else if (response.data.hasOwnProperty('errmsg') && response.data.errmsg !== "") {
      if (response.data.errmsg === 'not authenticated') {
        window.location.href = base + "/login";
      } else if (response.data.errmsg === 'authenticated') {
        window.location.href = base + "/";
      } else if (response.data.errmsg === 'expired') {
        window.location.href = base + "/pay";
      } else {
        ElMessage.error(response.data.errmsg)
      }
      return Promise.reject(response)
    }
  }
  return response
}, function (error) {
  if (isLoading) {
    loadingInstance.close()
  }
  ElMessage({ showClose: true, message: '网络异常，请刷新页面', duration: 2000, grouping: true, })
  return error
})

const httpNoLoading = axios.create({
  baseURL: 'api',
  timeout: 60000,
  headers: {
  }
})

httpNoLoading.interceptors.request.use(function (config) {
  setRequestHeader(config)
  return config
}, function (error) {
  return error
})

httpNoLoading.interceptors.response.use(function (response) {
  if (response.data.hasOwnProperty('check_info') && response.data.check_info !== "") {
    if (response.data.check_info === 'not authenticated') {
      window.location.href = base + "/login";
    } else if (response.data.check_info === 'authenticated') {
      window.location.href = base + "/";
    } else if (response.data.check_info === 'expired') {
      window.location.href = base + "/pay";
    } else {
      ElMessage.error(response.data.check_info)
    }
    return Promise.reject(response)
  } else if (response.data.hasOwnProperty('errmsg') && response.data.errmsg !== "") {
    if (response.data.errmsg === 'not authenticated') {
      window.location.href = base + "/login";
    } else if (response.data.errmsg === 'authenticated') {
      window.location.href = base + "/";
    } else if (response.data.errmsg === 'expired') {
      window.location.href = base + "/pay";
    } else {
      ElMessage.error(response.data.errmsg)
    }
    return Promise.reject(response)
  }
  return response
}, function (error) {
  ElMessage({ showClose: true, message: '网络异常，请刷新页面', duration: 2000, grouping: true, })
  return error
})

function setRequestHeader(config) {
  if (config.data === undefined || config.data === null) {
    config.data = ""
  }
  var sign = getAuthorization(config.data)
  var auth = LStorage.getItem('auth_stock')
  if (auth === undefined || auth === null) {
    auth = ""
  }
  config.headers = { sign: sign, auth: auth }
  // console.log(config.headers)
  // console.log(config.url)
  return config
}

export { http, httpNoLoading }
